import { useContext } from "react";
import { AppContext } from "../context/AppContext";
import BlogDetails from "../components/BlogDetails"
import Spinner from "./Spinner";

export default function Blogs() {
  const { posts, loading } = useContext(AppContext);

  return (
    <div className="w-11/12 h-full min-h-screen max-w-[750px] flex flex-col items-center text-white mb-10">
      {loading ? 
        <Spinner/>
        : posts.length === 0 ? (
        <div>
          <p className="text-center font-bold text-3xl">No Blogs Found!</p>
        </div>
      ) : (
        posts.map((post) => (
          <BlogDetails key={post.id} post={post}/>
        ))
      )}
    </div>
  );
}
